<template>
  <div id="app">
    <Header titulo="Atención al cliente" />
    <div class="container">
      <h2 id="dejanos">Dejanos tus datos y <span>nos contactaremos con vos</span></h2>
      <p class="intro-copy">Si querés comunicarte por teléfono, llamanos al 0800-888-8338 (lunes a viernes de 9:00 a 18:00 h).</p>
    </div>
    <Form :motivos="motivos" :formas="formas" :modelos="modelos" :concesionarias="concesionarias" />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Form from "./components/Form.vue";

import axios from "axios";

const API_URL =
  window.location.hostname === "localhost"
    ? "https://d6-precios.vwcontenidos.com.ar/api/contacto"
    : "https://d6-precios.vwcontenidos.com.ar/api/contacto";

export default {
  name: "app",
  components: {
    Header,
    Form
  },
  data() {
    return {
      loading: true,
      motivos: [],
      formas: [],
      modelos: [],
      concesionarias: []
    };
  },
  mounted: function() {
    axios.get(API_URL).then(response => {
      this.motivos = response.data.motivos;
      this.formas = response.data.formas;
      this.modelos = response.data.modelos;
      axios.get('https://institucional.vwcontenidos.com.ar/api/informacion/atencion-al-cliente').then(response => {
        this.concesionarias = response.data.concesionarias;
      });
      this.loading = false;
      document.title = "Atención al Cliente | Volkswagen Argentina";
    });
  }
};
</script>

<style lang="scss">
@import "./assets/scss/_fonts.scss";

#app {
  font-family: "vw-head", Arial, Helvetica, sans-serif;
  padding-bottom: 10em;
  padding-top: 7em;
  @media (max-width: 1441px) {
    font-size: 12px;
  }

  #dejanos {
    font-weight: 200;
    color: #001e50;
    font-size: 4.3em;
    padding: 0.8em 0 0;
    letter-spacing: -0.015em;
    @media (max-width: 669px) {
      font-size: 3.1em;
    }
    span {
      font-weight: 400;
      letter-spacing: -0.004em;
    }
  }

  .intro-copy {
    font-size: 1.35em;
    font-family: "vw-head", Arial, Helvetica, sans-serif;
    margin: 1.7em auto 2.2em;
    letter-spacing: -0.004em;
    @media (max-width: 669px) {
      font-size: 2.1em;
      font-family: "vw-head", Arial, Helvetica, sans-serif;
      margin: 1em auto 2.2em;
      letter-spacing: 0;
      padding-right: 1.3em;
    }
  }

  @media (min-width: 1640px) {
    .container {
      width: 100%;
      max-width: 1640px;
    }
  }
  .vfl-label,
  .vfl-label-on-input,
  .vfl-label-on-focus {
    color: #001e50;
  }
  .select .vfl-label,
  .select .vfl-label-on-input,
  .select .vfl-label-on-focus {
    margin-left: 4px;
  }
  .has-error .vfl-label,
  .has-error .vfl-label-on-input,
  .has-error .vfl-label-on-focus {
    color: #dd2c00;
  }
}

.swal2-popup {
  font-size: 1em;
}
#swal2-title {
  line-height: 1.3;
  font-family: "vw-head", Arial, Helvetica, sans-serif;
  font-weight: 200;
}

.swal2-popup .swal2-actions button.swal2-confirm {
  border: none !important;
  border-radius: 22px;
  font-size: 1em;
  padding: 0.5em 2.8em 0.6em;
  letter-spacing: -0.04em;
  color: #fff;
  background: #001e50;
  margin-bottom: 1em;
  font-family: "vw-head", Arial, Helvetica, sans-serif;
  font-weight: 200;
  &:focus,
  &:active {
    box-shadow: none;
    outline: none;
  }
}

#swal2-content a.btn {
  border: 1px solid #001e50;
  border-radius: 22px;
  font-size: 1.2em;
  padding: 0.6em 2.8em;
  letter-spacing: -0.04em;
  color: #001e50;
  background: white;
  margin-bottom: 1em;
  &:focus,
  &:active {
    box-shadow: none;
    outline: none;
  }
}

.swal2-popup #swal2-content {
  font-size: 1.1em;
}
</style>
